
import { toast } from "sonner";
import { DadosIrradiacao } from "@/types";

export const fetchCepData = async (cepFormatted: string) => {
  try {
    // Use OpenCep API
    const response = await fetch(`https://opencep.com/v1/${cepFormatted}`);
    
    if (!response.ok) {
      throw new Error("Serviço de CEP indisponível");
    }
    
    const data = await response.json();
    
    if (data.erro) {
      throw new Error("CEP não encontrado");
    }
    
    // Map OpenCep data format to the expected format
    const mappedData = {
      cep: data.cep,
      logradouro: data.logradouro,
      complemento: data.complemento,
      bairro: data.bairro,
      localidade: data.localidade,
      uf: data.uf,
      regiao: ""  // OpenCep doesn't provide region information
    };
    
    return mappedData;
  } catch (error: any) {
    toast.error(error.message || "Erro ao buscar CEP");
    return null;
  }
};

export const gerarDadosMensaisSimulados = (mediaAnual: number, meses: string[]) => {
  return meses.map((mes, index) => {
    const variacaoSazonal = index < 6 
      ? mediaAnual * (1 - (5 - index) * 0.08)
      : mediaAnual * (1 + (index - 6) * 0.08);
    
    const valor = variacaoSazonal + (Math.random() * 0.5 - 0.25);
    
    return {
      mes,
      valor: Number(valor.toFixed(2))
    };
  });
};

export const fetchIrradiationData = async (cepFormatted: string, latitude: number, longitude: number, meses: string[]) => {
  try {
    // Generate simulated data instead of calling an actual API
    const mediaAnual = 4.8 + Math.random() * 1.2;
    const dadosMensais = gerarDadosMensaisSimulados(mediaAnual, meses);
    
    // Find min and max values
    const valoresMensais = dadosMensais.map(d => d.valor);
    const minIrradiacao = Math.min(...valoresMensais);
    const maxIrradiacao = Math.max(...valoresMensais);
    
    // Find months with min and max values
    const mesMenorValor = dadosMensais.find(d => d.valor === minIrradiacao)?.mes || "Junho";
    const mesMaiorValor = dadosMensais.find(d => d.valor === maxIrradiacao)?.mes || "Dezembro";
    
    // Return simulated data
    return {
      cep: cepFormatted,
      latitude,
      longitude,
      irradiacaoMedia: mediaAnual,
      minIrradiacao,
      maxIrradiacao,
      mesMin: mesMenorValor,
      mesMax: mesMaiorValor,
      dadosMensais
    } as DadosIrradiacao;
  } catch (error) {
    console.error("Erro ao buscar dados de irradiação:", error);
    toast.error("Erro ao buscar dados de irradiação. Tente novamente.");
    return null;
  }
};
